<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="parasitUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="parasits"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-parasit
      :parasit="{ name: '', germanName: '', latinName: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-parasit
      :key="parasitUpdateKey"
      :parasit="selectedParasit"
      :visible="dialogType === 'update'"
      :id="selectedParasit.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-parasit
      :visible="dialogType === 'delete'"
      :parasit="selectedParasit"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-parasit>
  </div>
</template>

<script>
import CreateParasit from "./CreateParasit";
import UpdateParasit from "./UpdateParasit";
import DeleteParasit from "./DeleteParasit";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateParasit,
    UpdateParasit,
    DeleteParasit,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "name" },
        { text: "Latein", value: "latinName" },
        { text: "Deutsch", value: "germanName" },
        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      parasitUpdateKey: null,
      parasitList: [],
      isLoading: false,
      dialogType: "",
      selectedParasit: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "parasits"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchParasits", "createParasit", "updateParasit"]),
    editParasit(parasit) {
      this.selectedParasit = { ...parasit };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },

    openModal(type, parasit) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedParasit = { ...parasit };
      }
    },
    openDeleteModal(type, parasit) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedParasit = { ...parasit };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedParasit = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedParasit = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createParasit(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateParasit(item);
      this.parasitUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchParasits()
        .then(() => {
          //      this.$store.commit("setCoverageTypeResults", response.data);
          this.coverages = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    handleSearch(query) {
      this.getSearchquery = query;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
